
import { Options, Vue } from 'vue-class-component';
import { PropSync, Watch } from 'vue-property-decorator';

@Options({
	name: 'CreateGoalFolder',
})
export default class CreateGoalFolder extends Vue {
	@PropSync('error', { default: '', type: String })
	error!: string;

	@PropSync('inProgress', { default: false, type: Boolean })
	inProgress!: boolean;

	goalData = {
		name: '',
	};

	errorMes = {
		name: '',
		status: true,
	};

	@Watch('error')
	onErrorPropsChange(value: string) {
		this.errorMes['name'] = `Tên thư mục ${value}`;
	}

	//----------------------- 🤍 Methods 🤍 -----------------------//
	submit() {
		this.errorMes = {
			name: '',
			status: true,
		};
		if (this.goalData['name']?.length <= 0) {
			this.errorMes['name'] = 'Tên thư mục không được bỏ trống';
			this.errorMes.status = true;
			setTimeout(() => {
				this.errorMes = {
					name: '',
					status: true,
				};
			}, 3000);
		}
		this.$emit('submit', this.goalData);
	}
}
